import { componentModes } from 'features/NewHotelDialog/constants'
import { prepareFormDataForSubmission } from 'features/NewHotelDialog/helpers'
import useForm from 'hooks/useForm'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import subsidiariesApi from 'services/api/subsidiaries'
import userApi from 'services/api/user'

import { validatePrepayPreferencesForm } from './helpers'

export const usePaymentPeriodData = options => {
  const { mode, onSave, addToast, nearestStartDate } = options || {}
  const [isLoading, setIsLoading] = useState(false)

  const [paymentPeriodData, handleFormChange, setPaymentPeriodData] = useForm({
    period: null,
    discount: '',
    monthlyRate: '',
    hasPremiumSupport: false,
    premiumSupportFee: '',
    selectedPackage: 'directfulCore',
    serviceStartDate: moment(nearestStartDate).format('YYYY-MM-DD'),
    salesPersonUserId: null,
    referrerId: null,
    newReferrerName: null
  })

  const [referrers, setReferrers] = useState([])
  const [salesAgents, setSalesAgents] = useState([])
  const isPreOnboardingCompleted = useSelector(
    s => s.hotelDetails.isPreOnboardingCompleted
  )

  // Reset premium support fee when premium support is disabled
  useEffect(() => {
    if (!paymentPeriodData.hasPremiumSupport) {
      setPaymentPeriodData({ premiumSupportFee: '' })
    }
  }, [paymentPeriodData.hasPremiumSupport, setPaymentPeriodData])

  // Fetch sales agents when in switchToPrepay mode
  useEffect(() => {
    if (mode === componentModes.switchToPrepay) {
      userApi.getSalesAgents().then(res => {
        setSalesAgents(res)
      })
    }
  }, [mode])

  // Fetch referrers when in switchToPrepay mode
  useEffect(() => {
    if (mode === componentModes.switchToPrepay) {
      subsidiariesApi.referrers.get().then(res => {
        setReferrers(res.map(r => ({ value: r.id, label: r.name })))
      })
    }
  }, [mode])

  // Handle form save
  const handleSave = () => {
    if (!validatePrepayPreferencesForm(paymentPeriodData, addToast)) {
      return
    }

    setIsLoading(true)
    const formDataToSubmit = prepareFormDataForSubmission(paymentPeriodData)

    if (mode === componentModes.switchToPrepay) {
      subsidiariesApi
        .switchToPrepay(formDataToSubmit)
        .then(() => {
          onSave()
        })
        .catch(err => {
          addToast(err.message, { appearance: 'error' })
        })
        .finally(() => {
          setIsLoading(false)
        })
    } else {
      subsidiariesApi.prepayPeriod
        .post(formDataToSubmit)
        .then(() => {
          onSave()
        })
        .catch(err => {
          addToast(err.message, { appearance: 'error' })
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }

  return {
    paymentPeriodData,
    handleFormChange,
    setPaymentPeriodData,
    referrers,
    salesAgents,
    isPreOnboardingCompleted,
    isLoading,
    handleSave
  }
}
